import React from 'react';
import { Button } from 'reactstrap';
import { ExportStatus } from './types';

interface ExportSuccessViewProps {
  exportStatus: ExportStatus;
  onClose: () => void;
}

const ExportSuccessView: React.FC<ExportSuccessViewProps> = ({
  exportStatus,
  onClose
}) => {
  if (!exportStatus || exportStatus.status !== 'completed' || exportStatus.success === false) return null;

  return (
    <div className="text-center">
      <div className="mb-4">
        <i className="icon-checkmark text-success" style={{ fontSize: '48px' }} />
      </div>
      
      <div className="alert alert-success text-left mb-4 flex flex-column">
        <h5 className="mb-3">{exportStatus.message || 'Export Successful!'}</h5>
        {exportStatus.export_id && (
          <small className="d-block">
            <strong>Export ID:</strong> {exportStatus.export_id}
          </small>
        )}
      </div>

      <div className="row">
        <div className="col-12 justify-content-end formbtn">
          <div className="btn-wrap btn--leftspace">
            <Button
              className="btn btn-primary"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportSuccessView; 